<template>
  <div class="ui center aligned container">
    <div class="ui images" v-viewer="options" v-if="image">
      <img :src="'https://static.ycyup.cn/mw690/' + image" :data-src="'https://static.ycyup.cn/large/' + image">
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Home',
  data () {
    return {
      image: '',
      options: {
        url: 'data-src'
      },
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      axios.get('/images/ycy').then(({ data }) => {
        this.image = data
      })
    }
  }
}
</script>

<style scoped>

</style>
